import {Component, OnInit, SecurityContext} from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml } from '@angular/platform-browser';

import {ActivatedRoute, Router} from '@angular/router';
import {NetworkHelperService} from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../../_config/strings';
import Swal from 'sweetalert2';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig } from '@hallysonh/ngx-imageviewer';
import {Usuario} from '../../../_model/Usuario';
import {Cliente} from '../../../_model/Cliente';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import * as moment from 'moment';
import { ChatService } from '../../../_services/chat.service';
import { count } from 'rxjs/operator/count';

declare var $: any;



@Component({
    selector: 'app-ver-editar-abastecimiento',
    templateUrl: './ver-editar-abastecimiento.component.html',
    styleUrls: ['./ver-editar-abastecimiento.component.scss'],
})

export class VerEditarAbastecimientoComponent implements OnInit {

    FORMS: any;
    API: any;
    GENERALES: any;
    PAGE: any;

    IdAbas: any;
    idContrato: any;

    sucursalesUsuaio = [{
        id: '',
        nombre: ''
    }];
    // detallesAbastecimiento
    concepto = '';
    dias = '';
    contrato = '';
    documentoSelecionadoTipo = '';
    // Fechas
    fechaFinFormato: any;
    fechaFormato: any;
    fecha1: any;
    fecha2: any;

    statusCliente = {
        id: '',
        nombre: '',
        color: '',
        estatus: ''
    };

    incremento = 1;
    contacto = [];

    tipoCliente = '';

    nombreCompleto = '';
    rfc = '';
    // Contrato
    contratoAidi = '';
    contratoNumero = '';
    contratoFechaInicio  = '';
    contratoFechaFin = '';
    contratoRuta  = '';
    contratoEstatusNombre = '';
    contratoEstatusColor = '';
    contratoEstatusEstatus = '';
    contratoObra = '';
    mostrarContrato = '';
    archivo = '';
    documentoTipo = false;
    // estatusDocumentoEstatus = '';
    btnRegistrarContrato = false;
    boolMostrarRS = false;
    clienteRazonSocial;

    // Orden de trabajo
    ordenExiste = false;
    selectNuevaOrden = false;
    btnAutorizarOrdenTrabajo = false;
    ordenId = 0;
    ordenCliente;
    ordenNombreObra;
    ordenCelular;
    ordenDias;
    ordenCantidadTotal;
    ordenEmail;
    ordenVehiculo;
    ordenMontaje;
    ordenDesmontaje;
    ordenFecha;
    ordenPeso;
    ordenTipo;
    ordenMateriales = [];
    ordenIconoForma;
    ordenIconoColor;
    ordenString;
    arrayCotizaciones = [];
    vistaNombreCliente;
    vistaCotizacionCliente;
    vistaCotizacionDescripcion;
    vistaCotizacionObra;
    vistaCotizacionUsuario;
    cotizacionNombre;
    cotizacionId;
    btnGuardarNuevaOrdenTrabajo = false;
    // Orden de trabajo

    ine = '';
    bandera = false;

    iconoForma = '';
    iconoColor = '';
    iconoFormaContrato = '';
    iconoColorContrato = '';

    todosLosDocumentos = [];
    incrementoDocumentos = 1;

    public usuario: Usuario = new Usuario();
    public cliente: Cliente;
    public innerHtml: SafeHtml;
    public innerHtmlContrato: SafeHtml;
    pay: string = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
    pdfSrc: string;
    // Garantias
    contratoInfo = [];
    facturasInfo = [];
    pagareInfo = [];
    ordenInfo = [];
    avisoInfo = [];
    ineAvalInfo = [];
    domicilioAvalInfo = [];
    otroUnoInfo = [];
    otroDosInfo = [];
    ineInfo = [];
    domicilioInfo = [];
    comentariosContratoArray = [];
    estatusFinalDocumento = '';
    tipoDeGarantia = '';
    mensajeNotificacionAR;
    mensajeNotificacionAutorizadoAR;

    loginLoader = false;
    bgLoading = true;
    idCliente: any;
    permisosArray = [];
    deshabilitarCamposPermisoEditar = true;
    deshabilitarFecha = true;
    btnAutorizarCliente = false;
    btnGuardarGarantias = false;
    btnAutorizarFactura = false;
    btnActualizarContrato = false;
    estatusAbastecimiento = '';
    tipoContrato: string;

    public imageSrc: string;
    public currentIdDocumento: any;
    public currentComentariosDocumento = [];
    public currentMensajeComentarioPopUp = '';
    public enviandoMensajeComentarioPopUp = false;

    mostrarBotones = [{
        autorizarClienteBtn: false,
        autorizarDocumentoBtn: false,
        autorizarOrdenBtn: false,
        popUpHeaderText: '',
        estatus: ''
    }];

    visto = false;
    vistoContrato = false;

    // Calendario Inicio
    fechaDeInicio = '';
    // fechaDeFin: any;
    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'yyyy/mm/dd',
        markCurrentDay: true,
        markCurrentMonth: true,
    };
    // Caledario Fin

    constructor(
        private route: ActivatedRoute,
        private network: NetworkHelperService,
        private rutas: Router,
        private chat: ChatService,
        private sanitizer: DomSanitizer
    ) {
        this.idCliente = this.route.snapshot.paramMap.get('id');
        this.FORMS = FORMS;
        this.API = API;
        this.GENERALES = GENERALES;
        this.PAGE = PAGE;
        this.usuario = JSON.parse( localStorage.getItem('usuario') );
        this.cliente = new Cliente();
        this.route.params.take(1).subscribe((params: any) => {
            this.IdAbas = params['idAbastecimiento'];
            this.idContrato = params['idContrato'];
        });
        // Reload Page
        // this.rutas.routeReuseStrategy.shouldReuseRoute = function() {return false; };
    }

    ngOnInit() {
        this.getPermisos();
        this.detallesContrato();
        // setTimeout(() => {this.detallesAbastecimiento(); }, 500);
        this.detallesAbastecimiento();
        this.getCliente();
        // console.log( this.IdAbas );
        this.cotizacionesAceptadas();
    }

    getPermisos() {
        const peticion = {
            userId: this.usuario.userId,
            codigoFuncionalidad: 'ABAVER'
        };
        this.network.callSecureService(
            this.API.user.permisosFuncionalidad,
            'POST',
            peticion )
            .subscribe((response: any) => {
                // console.log( response );
                // Se obtienen los permisos de poder mostrar elementos de la vista.
                this.permisosArray = response.Mensaje;
                const editarCliente = this.permisosArray.find( permiso => permiso === 'CONEDIT' );
                const autorizarClientePermiso = this.permisosArray.find( permiso => permiso === 'CONAUTO' );
                const guardarGarantias = this.permisosArray.find( permiso => permiso === 'ABACREA' );
                const autorizarFactura = this.permisosArray.find( permiso => permiso === 'FACVER' );
                const autorizarOrdenTrabajo = this.permisosArray.find( permiso => permiso === 'ORDAUTO' );
                if (editarCliente) {
                    this.deshabilitarCamposPermisoEditar = false;
                    // deshabilitarFecha: Deshabilita los input fecha y duración de servicio.
                    this.deshabilitarFecha = false;
                    // btnActualizarContrato variable utilizada para mostrar el botón solamente a los usuarios con el permiso.
                    this.btnActualizarContrato = true;
                } else {
                    this.btnActualizarContrato = false;
                }
                // Siguiente IF: Facultad de mostrarse si el usuario tiene permiso (en el botón "Autorizar contrato y garantiaas" de la vista)
                if (autorizarClientePermiso) {
                    this.btnAutorizarCliente = true;
                }
                // Siguiente IF: Facultad de mostrarse si el usuario tiene permiso (en el botón "Guardar" de la vista)
                if (guardarGarantias) {
                    this.btnGuardarGarantias = true;
                }
                // Botón aparecerá si cuenta con el permiso de autorizar la factura
                if (autorizarFactura) {
                    this.btnAutorizarFactura = true;
                }
                if (autorizarOrdenTrabajo) {
                    this.btnAutorizarOrdenTrabajo = true;
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }
    // Ete si
    detallesAbastecimiento() {
        const identificadorAbastecimiento = {
            idAbastecimiento: this.IdAbas,
        };
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos + '/' + this.API.user.detalles,
            'POST',
            identificadorAbastecimiento )
            .subscribe((response: any) => {
                console.log(response);
                if (response.Estatus === 200) {
                    this.concepto = response.Mensaje.abastecimiento.concepto;
                    // Obtenemos la fecha de lo recibido y aplicamos el método split para dividirlo en array
                    this.fecha1 = response.Mensaje.abastecimiento.fechaInicio.split('T');
                    // En fecha1 indicamos el índice del array obtenido con la función split para obtener únicamente el segmento deseado.
                    this.fechaDeInicio = this.fecha1[0];
                    this.fecha2 = response.Mensaje.abastecimiento.fechafin.split('T');
                    this.fechaFinFormato = this.fecha2[0];
                    this.dias = response.Mensaje.abastecimiento.dias;
                    this.fechaFormato = moment(this.fechaDeInicio).add(this.dias, 'days').format('YYYY-MM-DD');
                    // this.finServicioFecha = moment(fecha2['_i']).add(this.dias, 'days');
                    // Orden de trabajo
                    this.ordenCliente = response.Mensaje.ordenTrabajo.clienteCotizado;
                    if ( this.ordenCliente !== undefined ) {
                        this.ordenExiste = true;
                        this.ordenId = response.Mensaje.ordenTrabajo.id;
                        this.ordenCelular = response.Mensaje.ordenTrabajo.celularCotizado;
                        this.ordenNombreObra = response.Mensaje.ordenTrabajo.descripcion;
                        this.ordenEmail = response.Mensaje.ordenTrabajo.emailCotizado;
                        this.ordenTipo = response.Mensaje.ordenTrabajo.tipoCotizacion;
                        this.ordenMontaje = response.Mensaje.ordenTrabajo.montaje;
                        this.ordenDesmontaje = response.Mensaje.ordenTrabajo.desmontaje;
                        this.ordenFecha = response.Mensaje.ordenTrabajo.fecha;
                        this.ordenCantidadTotal = response.Mensaje.ordenTrabajo.ventaTotal;
                        for (const material of response.Mensaje.ordenTrabajo.material) {
                            this.ordenMateriales.push({
                                codigo: material.codigo,
                                familia: material.familia,
                                descripcion: material.descripcion,
                                cantidad: material.cantidad
                            });
                        }
                    }
                    // Orden de trabajo
                    this.estatusAbastecimiento = response.Mensaje.abastecimiento.estatus.estatus;
                    console.log( this.estatusAbastecimiento );
                    this.archivo = 'GARANTIAS';
                    for (const garantia of response.Mensaje.garantias) {
                        switch (garantia.estatus.estatus) {
                            // Autorizado
                            case 'AUTCOMP': {
                                this.iconoForma = 'mdi mdi-checkbox-multiple-marked-circle';
                                this.iconoColor = 'springgreen';
                                break;
                            }
                            // Pendiente por revisar
                            case 'AUTPEND': {
                                this.iconoForma = 'mdi mdi-alert-box';
                                this.iconoColor = 'orange';
                                break;
                            }
                            // Autorización denegada
                            case 'AUTDENE': {
                                this.iconoForma = 'mdi mdi-close-box';
                                this.iconoColor = 'red';
                                break;
                            }
                            // Sin documento
                            case 'NOTEXIS': {
                                this.iconoForma = 'mdi mdi-close-outline';
                                this.iconoColor = 'black';
                                break;
                            }
                            default:
                                // console.log( 'No entró en ningún estatus' );
                        }
                        // PAGARÉ
                        if (garantia.tipoDocumento === 'PAGARE') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.pagareInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.pagareInfo);
                        // FACTURA
                        } else if (garantia.tipoDocumento === 'FACTURA') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.facturasInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.facturasInfo);
                        // ORDEN DE TRABAJO
                        } else if (garantia.tipoDocumento === 'ORDENTRABAJO') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.ordenInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.ordenInfo);
                        // COMPROBANTE DE PAGO
                        } else if (garantia.tipoDocumento === 'AVISO') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.avisoInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.avisoInfo);
                        // INE AVAL
                        } else if (garantia.tipoDocumento === 'INEAVAL') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.ineAvalInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.ineAvalInfo);
                        // DOMICILIO AVAL
                        } else if (garantia.tipoDocumento === 'DOMICILIOAVAL') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.domicilioAvalInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.domicilioAvalInfo);
                            // Otro UNO
                        } else if ( garantia.tipoDocumento === 'OTRO1' ) {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.otroUnoInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor : this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.otroUnoInfo);
                            // Otro DOS
                        } else if (garantia.tipoDocumento === 'OTRO2') {
                            const rutaGarantias = garantia.ruta ? this.API.fase2 + garantia.ruta : null;
                            this.otroDosInfo = [{
                                id: garantia.idGarantia,
                                ruta: rutaGarantias,
                                estatus: garantia.estatus.estatus,
                                color: garantia.estatus.color,
                                nombre: garantia.estatus.nombre,
                                iconoFor : this.iconoForma,
                                iconoCol: this.iconoColor,
                                tipoDocumento: garantia.tipoDocumento,
                                comentVisto: this.visto
                            }];
                            this.todosLosDocumentos.push(this.otroDosInfo);
                        }
                    }
                } else {
                    Swal('Oops', response.Mensaje, 'error');
                }

                this.todosLosDocumentos.forEach(element => {
                    this.recorridoVisto(element[0]);
                });

            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    detallesContrato () {
        this.comentariosContratoArray = [];
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.idContrato,
            'GET',
            null )
            .subscribe((response: any) => {
                console.log(response);
                if (response.Estatus === 200) {
                    this.nombreCompleto = response.Mensaje.cliente.nombre + ' ' + response.Mensaje.cliente.paterno + ' ' + response.Mensaje.cliente.materno;
                    this.rfc = response.Mensaje.cliente.rfc;
                    this.contratoAidi = response.Mensaje.noContrato.idContrato;
                    this.contratoNumero = response.Mensaje.noContrato.noContrato;
                    this.contratoFechaInicio = response.Mensaje.noContrato.fechaInicio;
                    this.contratoFechaFin = response.Mensaje.noContrato.fechaFin;
                    this.contratoRuta = response.Mensaje.noContrato.ruta;
                    this.contratoEstatusNombre = response.Mensaje.noContrato.estatus.nombre;
                    this.contratoEstatusColor = response.Mensaje.noContrato.estatus.color;
                    this.contratoEstatusEstatus = response.Mensaje.noContrato.estatus.estatus;
                    this.contratoObra = response.Mensaje.noContrato.obra;
                    this.estatusFinalDocumento = response.Mensaje.noContrato.estatus.nombre;
                    this.comentariosContratoArray = response.Mensaje.noContrato.comentarioContrato;
                    this.mostrarContrato = this.API.contratos + this.contratoRuta;
                    let comentario = response.Mensaje.noContrato.comentarioContrato.find(elemento => elemento.visto === false );
                    if ( comentario ) {
                        this.vistoContrato = true;
                    }
                    this.archivo = 'CONTRATO';
                    // Realizados split a la ruta del contrato para compararlo y modificar el PupUp.
                    let tipo;
                    tipo = this.mostrarContrato.split('.');
                    this.tipoContrato = tipo[tipo.length -1];
                    this.imageSrc = this.mostrarContrato;
                    this.setInnerHtml(this.mostrarContrato);
                    // Control de botones de abastecimientos
                    if ( this.contratoEstatusEstatus === 'AUTCOMP' || this.contratoEstatusEstatus === 'AUTSINF') {
                        this.btnRegistrarContrato = false;
                        // document.getElementById('titulo').style.opacity = '0';
                    } else {
                        this.btnRegistrarContrato = true;
                    }
                    // Switch
                    switch (this.contratoEstatusEstatus) {
                        // Autorizado
                        case 'AUTCOMP': {
                            this.iconoFormaContrato = 'mdi mdi-checkbox-multiple-marked-circle';
                            this.iconoColorContrato = 'springgreen';
                            break;
                        }
                        // Pendiente por revisar
                        case 'AUTPEND': {
                            this.iconoFormaContrato = 'mdi mdi-alert-box';
                            this.iconoColorContrato = 'orange';
                            break;
                        }
                        // Autorización denegada
                        case 'AUTDENE': {
                            this.iconoFormaContrato = 'mdi mdi-close-box';
                            this.iconoColorContrato = 'red';
                            break;
                        }
                        // Sin documento
                        case 'NOTEXIS': {
                            this.iconoFormaContrato = 'mdi mdi-close-outline';
                            this.iconoColorContrato = 'black';
                            break;
                        }
                        case 'AUTPREE': {
                            this.iconoFormaContrato = 'mdi  mdi-file-powerpoint';
                            this.iconoColorContrato = 'brown';
                            break;
                        }
                        default:
                            // console.log( 'No entró en ningún estatus' );
                    }
                    // Switch
                    if (this.contratoEstatusEstatus === 'AUTPREE' || this.contratoEstatusEstatus === 'AUTCOMP' || this.contratoEstatusEstatus === 'AUTSINF') {
                        this.btnRegistrarContrato = false;
                    } else {
                        this.btnRegistrarContrato = true;
                    }
                    // this.iconoFormaContrato = 'mdi mdi-checkbox-multiple-marked-circle';
                    // this.iconoColorContrato = 'springgreen';
                } else {
                    Swal('Oops', 'ocurrió un error', 'warning');
                }
                // this.detallesCliente = [];
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    getCliente () {
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente,
            'GET',
            null )
            .subscribe((response: any) => {
                // console.log(response);
                if (response.Estatus === 206) {
                    Swal('Oops', response.Mensaje, 'warning');
                } else {
                    // console.log(response.Mensaje);
                    this.cliente = response.Mensaje.cliente;
                    this.sucursalesUsuaio = [];
                    this.sucursalesUsuaio.push({
                        id: response.Mensaje.cliente.sucursalId,
                        nombre: response.Mensaje.cliente.sucursalNombre,
                    });
                    // Obtener el tipo de cliente
                    this.tipoCliente = response.Mensaje.cliente.tipo_cliente;
                    // console.log( this.tipoCliente );
                    if ( this.tipoCliente === 'MORAL' ) {
                        this.boolMostrarRS = true;
                        this.clienteRazonSocial = response.Mensaje.cliente.razonSocial;
                    }
                    // Obtención delos documentos
                    // reiniciar variable
                    // this.todosLosDocumentos = [];
                    for (const documento of response.Mensaje.documentos) {
                        switch (documento.estatus.estatus) {
                            case 'AUTCOMP': {
                                this.iconoForma = 'mdi mdi-checkbox-multiple-marked-circle';
                                this.iconoColor = 'springgreen';
                                break;
                            }
                            case 'AUTPEND': {
                                this.iconoForma = 'mdi mdi-alert-box';
                                this.iconoColor = 'orange';
                                break;
                            }
                            case 'AUTDENE': {
                                this.iconoForma = 'mdi mdi-close-box';
                                this.iconoColor = 'red';
                                break;
                            }
                            case 'NOTEXIS': {
                                this.iconoForma = 'mdi mdi-close-outline';
                                this.iconoColor = 'black';
                                break;
                            }
                            default:
                                console.log( 'No entró en ningún estatus' );
                        }
                        // INE
                        if ( documento.tipoDocumento === 'INE'  ) {
                            const rutaResp = documento.ruta ? this.API.fase2 + documento.ruta : null;
                            this.ineInfo = [{
                                id: documento.id,
                                ruta: rutaResp,
                                estatus: documento.estatus.estatus,
                                color: documento.estatus.color,
                                nombre: documento.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor
                            }];
                            // this.todosLosDocumentos.push(this.ineInfo);
                            // SAT
                        } else if (documento.tipoDocumento === 'DOMICILIO' ) {
                            const rutaResp = documento.ruta ? this.API.fase2 + documento.ruta : null;
                            this.domicilioInfo = [{
                                id: documento.id,
                                ruta: rutaResp,
                                estatus: documento.estatus.estatus,
                                color: documento.estatus.color,
                                nombre: documento.estatus.nombre,
                                iconoFor: this.iconoForma,
                                iconoCol: this.iconoColor
                            }];
                           // this.todosLosDocumentos.push(this.domicilioInfo);
                        }
                    }
                    $('.dropify').dropify({});
                    this.statusCliente = response.Mensaje.cliente.estatus;
                    this.bgLoading = false;
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    advertenciaSwal () {
        // Swal('Atención', '¿Estás seguro de modificar este valor?', 'info');
        // alert('¿Está seguro de modificar este valor?');
    }
    // Ete no...
    documentoPopUp( idDocumento, tipoDocumento ) {
        this.documentoSelecionadoTipo = tipoDocumento;
        // console.log( this.documentoSelecionadoTipo );
        const autorizarCliente = this.permisosArray.find( permiso => permiso === 'CONAUTO' );
        const autorizarDocumento = this.permisosArray.find( permiso => permiso === 'DOCAUTO' );
        const autorizarOrden = this.permisosArray.find( permiso => permiso === 'ORDAUTO' );
        this.currentIdDocumento = '';
        if (autorizarCliente) {
            this.mostrarBotones[0].autorizarClienteBtn = true;
        }
        if (autorizarDocumento) {
            this.mostrarBotones[0].autorizarDocumentoBtn = true;
        }
        if (autorizarOrden) {
            if (this.estatusAbastecimiento === 'ORDPEND') {
            this.mostrarBotones[0].autorizarOrdenBtn = true;
            }
        }
        // FACTURA...
        if ( tipoDocumento === 'FACTURA') {
            this.currentIdDocumento = this.facturasInfo[0].id;
            this.imageSrc = this.facturasInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Factura';
        // PAGARÉ
        } else if ( tipoDocumento === 'PAGARE') {
            this.currentIdDocumento = this.pagareInfo[0].id;
            this.imageSrc = this.pagareInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Pagaré';
        // ORDEN DE TRABAJO
        } else if ( tipoDocumento === 'ORDENTRABAJO') {
            this.currentIdDocumento = this.ordenInfo[0].id;
            this.imageSrc = this.ordenInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Orden de trabajo';
        // COMPROBANTE DE PAGO
        } else if ( tipoDocumento === 'AVISO') {
            this.currentIdDocumento = this.avisoInfo[0].id;
            this.imageSrc = this.avisoInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Comprobante de pago';
        // INE AVAL
        } else if ( tipoDocumento === 'CONTRATO') {
            this.currentIdDocumento = this.contratoAidi;
            this.imageSrc = this.mostrarContrato;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Contrato';
        // DOMICILIO AVAL
        } else if ( tipoDocumento === 'DOMICILIOAVAL') {
            this.currentIdDocumento = this.domicilioAvalInfo[0].id;
            this.imageSrc = this.domicilioAvalInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Comprobante de domicilio (AVAL)';
        // OTRO UNO
        } else if ( tipoDocumento === 'OTRO1' ) {
            this.currentIdDocumento = this.otroUnoInfo[0].id;
            this.imageSrc = this.otroUnoInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Documento extra 1';
        // OTRO DOS
        } else if ( tipoDocumento === 'OTRO2' ) {
            this.currentIdDocumento = this.otroDosInfo[0].id;
            this.imageSrc = this.otroDosInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Buró de crédito';
        // INE Autorizado
        } else if ( tipoDocumento === 'INE') {
            this.currentIdDocumento = this.ineInfo [0].id;
            this.imageSrc = this.ineInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'INE (Aval)';
        // DOMICILIO Autorizado
        } else if ( tipoDocumento === 'DOMICILIO' ) {
            this.currentIdDocumento = this.domicilioInfo[0].id;
            this.imageSrc = this.domicilioInfo[0].ruta;
            let tipo;
            tipo = this.imageSrc.split('.');
            this.tipoDeGarantia = tipo[tipo.length -1];
            this.setInnerHtml(this.imageSrc);
            this.mostrarBotones[0].popUpHeaderText = 'Domicilio (Aval)';
        }
    }

    recorridoVisto( documento) {
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos + '/' + this.API.user.garantias + '/' + documento.id,
            'GET',
            null )
            .subscribe((response: any) => {
                let existeComentarioNovisto = response.Mensaje.comentarios.find(elemento => elemento.visto === false);
                if (existeComentarioNovisto) {
                    switch (documento.tipoDocumento) {
                        case 'PAGARE': {
                            this.pagareInfo[0].comentVisto = true;
                            break;
                        }
                        case 'AVISO': {
                            this.avisoInfo[0].comentVisto = true;
                            break;
                        }
                        case 'INEAVAL': {
                            this.ineAvalInfo[0].comentVisto = true;
                            break;
                        }
                        case 'DOMICILIOAVAL': {
                            this.domicilioAvalInfo[0].comentVisto = true;
                            break;
                        }
                        case 'OTRO1': {
                            this.otroUnoInfo[0].comentVisto = true;
                            break;
                        }
                        case 'OTRO2': {
                            this.otroDosInfo[0].comentVisto = true;
                            break;
                        }
                        case 'ORDENTRABAJO': {
                            this.ordenInfo[0].comentVisto = true;
                            break;
                        }
                    }
                }
                }, err => {
                    console.log(err);
                    Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                }
            );
    }
    comentarioPopUp( documento ) {
        this.enviandoMensajeComentarioPopUp = false;
        this.currentIdDocumento = documento;
        this.currentComentariosDocumento = [];
        if (this.currentIdDocumento != null) {
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos + '/' + this.API.user.garantias + '/' + documento.id,
            'GET',
            null )
            .subscribe((response: any) => {
                    console.log( response );
                    this.currentComentariosDocumento = response.Mensaje.comentarios;
                }, err => {
                    console.log(err);
                    Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                }
            );
        }
    }

    enviarMensajeComentarioPopUp () {
        this.enviandoMensajeComentarioPopUp = true;
        const jsonData = {
            idGarantia: this.currentIdDocumento.id,
            comentario: this.currentMensajeComentarioPopUp
        };
        // Se vuelve a llamar al método para que se actualicen los comentarios.
        this.comentarioPopUp( this.currentIdDocumento);
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos + '/' + this.API.user.garantias + '/' + this.API.user.agregarComentario,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                this.currentComentariosDocumento = [];
                this.currentComentariosDocumento = response.Mensaje.comentarios;
                this.enviandoMensajeComentarioPopUp = false;
                this.currentMensajeComentarioPopUp = '';
                // this.comentarioPopUp(idGarantia, tipoDocumento);
                // == Targets de notificación ==
                let targets = response.Mensaje.notificacion;
                targets.forEach(e => {
                    const target = e.target;
                    const id = e.id;
                    let notificacionString =  'El usuario ' + this.usuario.userName + ' ha comentado un documento ';
                    let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                    this.sendMessageTest(target, notificacionString, url, id);
                });
                // == Targets de notificación ==
            }, err => {
                console.log(err);
                this.enviandoMensajeComentarioPopUp = false;
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }
    // Cambia de color el boton de ver documento
    cambiarEstatusDocumento (codFuncion) {
        const jsonData = {
            idDocumento: this.currentIdDocumento,
            estatus: codFuncion,
            tipoDocumento: this.documentoSelecionadoTipo,
            noContrato: this.contratoNumero,
            abastecimientoId: this.IdAbas
        };
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.garantias + '/' + this.API.user.autorizar,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                console.log(response);
                if (response.Estatus === 201) {
                  // response.Mensaje.estatus
                    if (codFuncion === 'AUTCOMP') {
                        Swal('Correcto', response.Mensaje.strings, 'success');
                        /*
                        let nombreCliente;
                        if ( this.tipoCliente === 'FISICA' ) {
                            nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                        } else if ( this.tipoCliente === 'MORAL' ) {
                            nombreCliente = this.cliente.razonSocial;
                        } else if ( this.tipoCliente === 'ESPECIAL' ) {
                            nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                        }
                        */
                        let nombreCliente;
                        this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                        if (this.documentoSelecionadoTipo === 'ORDENTRABAJO') {
                            for (const noti of response.Mensaje.notificacion) {
                                noti.forEach(element => {
                                    let target = element.target;
                                    let id = element.id;
                                    let notificacionString = 'El usuario ' + this.usuario.userName + ' ha autorizado una garantía del cliente: ' + nombreCliente + '. Ya puede salir el material de la Sucursal!';
                                    let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                                    this.sendMessageTest(target, notificacionString, url, id);
                                });
                            }
                        }
                        // this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.urlContrato, 'abastecimiento']);
                        // response.Mensaje.estatus.nombre
                    } else if (codFuncion === 'AUTDENE') {
                        let nombreCliente;
                        if ( this.tipoCliente === 'FISICA' ) {
                            nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                        } else if ( this.tipoCliente === 'MORAL' ) {
                            nombreCliente = this.cliente.razonSocial;
                        } else if ( this.tipoCliente === 'ESPECIAL' ) {
                            nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                        }
                        // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                        Swal('Correcto', response.Mensaje.strings, 'success');
                        // == Targets de notificación ==
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha rechazado una garantía del cliente: ' + nombreCliente;
                            let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                    } else if (codFuncion === 'ORDAUTO') {
                        let nombreCliente;
                        if ( this.tipoCliente === 'FISICA' ) {
                            nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                        } else if ( this.tipoCliente === 'MORAL' ) {
                            nombreCliente = this.cliente.razonSocial;
                        } else if ( this.tipoCliente === 'ESPECIAL' ) {
                            nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                        }
                        // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                        // Rechazar Orden de Trabajo.
                        for (const noti of response.Mensaje.notificacion) {
                            noti.forEach(element => {
                                let target = element.target;
                                let notificacionString = 'El usuario ' + this.usuario.userName + ' ha autorizado la Orden de Trabajo: ' + nombreCliente + '. Ya puede salir el material de la Sucursal y hacerse la Factura!';
                                let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                                this.sendMessage(target, notificacionString, url);
                            });
                        }
                    // Prueba
                    }
                    // Volver a llamar la función para actualizar el estatus(vista) de los documentos.
                    this.detallesAbastecimiento();
                } else {
                    Swal('Atención', response.Mensaje, 'warning');
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    ordenAceptarRechazar (codigoRevision) {
        console.log( this.ordenId );
        if ( !this.ordenId ) {
            this.ordenId = 0;
        }
        const JSONORDEN = {
            cotizacionId: this.ordenId,
            codigo: codigoRevision
        };
        console.log( JSONORDEN );
        this.network.callSecureService(
            this.API.user.orden + '/' + this.API.user.autorizar,
            'POST',
            JSONORDEN)
            .subscribe((response: any) => {
                console.log( response );
                if ( response.Estatus === 201 ) {
                    if ( codigoRevision === 'ORDDENE' ) {
                        this.selectNuevaOrden = true;
                    }
                }
                console.log( this.ordenId );
                // Switch
                switch (codigoRevision) {
                    // Autorizado
                    case 'ORDAUTO': {
                        this.ordenIconoForma = 'mdi mdi-checkbox-multiple-marked-circle';
                        this.ordenIconoColor = 'springgreen';
                        this.ordenString = 'Orden de trabajo autorizada';
                        break;
                    }
                    // Autorización denegada
                    case 'ORDDENE': {
                        this.ordenIconoForma = 'mdi mdi-close-box';
                        this.ordenIconoColor = 'red';
                        this.ordenString = 'Orden de trabajo rechazada';
                        break;
                    }
                    default:
                    // console.log( 'No entró en ningún estatus' );
                }
                // Switch
            }, err => {
                console.log( err );
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }
    // Subir la cotización de nuevo
    cotizacionesAceptadas() {
        this.network.callSecureService(
            this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.aceptada + '/' + this.API.user.listar,
            'GET',
            null )
            .subscribe((response: any) => {
                console.log(response);
                const cotizaciones = response.Mensaje;
                if (response.Estatus === 200) {
                    for (const coti of cotizaciones[0]) {
                        this.arrayCotizaciones.push({
                            id: coti.id,
                            nombre: coti.clienteCotizado,
                            descripcion: coti.descripcion,
                            obra: coti.obraCotizada,
                            usuario: coti.usuario
                        });
                        this.cotizacionNombre = coti.clienteCotizado;
                    }
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }

    idCoti() {
        this.vistaNombreCliente = this.arrayCotizaciones.find(dato => dato.id === Number(this.cotizacionId));
        this.vistaCotizacionObra = this.vistaNombreCliente.obra;
        this.vistaCotizacionDescripcion = this.vistaNombreCliente.descripcion;
        this.vistaCotizacionCliente = this.vistaNombreCliente.nombre;
        this.vistaCotizacionUsuario = this.vistaNombreCliente.usuario;
        this.btnGuardarNuevaOrdenTrabajo = true;
    }

    guardarNuevaOrden () {
        const JSONNEWORDEN = {
            abastecimientoId: this.IdAbas,
            cotizacionId: this.cotizacionId
        };
        this.network.callSecureService(
            this.API.user.orden + '/' + this.API.user.cambio,
            'POST',
            JSONNEWORDEN )
            .subscribe(( response: any ) => {
                console.log( response );
                Swal( 'Atención', response.Mensaje , 'info' );
                if ( response.Estatus === 201 ) {
                    Swal( 'Correcto', response.Mensaje, 'success' );
                }
                if ( response.Estatus === 206 ) {
                    Swal( 'Atención', response.Mensaje , 'info' );
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }
    // Subir la cotización de nuevo

    guardarGarantias() {
        if ( this.estatusAbastecimiento === 'AUTSPRO' && this.contratoEstatusEstatus === 'AUTPREE') {
            this.actualizarContrato();
            this.guardarAbastecimiento();
        } else if ( this.estatusAbastecimiento === 'AUTPEND' && this.contratoEstatusEstatus === 'AUTPEND' ) {
            this.actualizarContrato();
            this.guardarAbastecimiento();
        } else if ( this.estatusAbastecimiento === 'AUTPEND' && this.contratoEstatusEstatus === 'AUTCOMP' ) {
            this.guardarAbastecimiento();
        }
    }

    guardarAbastecimiento () {
        console.log( 'Entró abastecmiento' );
        const formularioGarantias: FormData = new FormData();
        this.loginLoader = true;

        formularioGarantias.append('noContrato', this.idContrato);
        formularioGarantias.append('abastecimientoId', this.IdAbas );
        formularioGarantias.append('concepto', this.concepto);

        formularioGarantias.append('fechaInicio', this.fechaDeInicio);
        formularioGarantias.append('fechaFin', this.fechaFormato);
        formularioGarantias.append('dias', this.dias);
        // Comentarios
        formularioGarantias.append('comentPagare', '');
        formularioGarantias.append('comentFactura', '');
        formularioGarantias.append('comentOrden', '');
        formularioGarantias.append('comentPago', '');
        formularioGarantias.append('comentIneAval', '');
        formularioGarantias.append('comentDomicilioAval', '');
        formularioGarantias.append('comentOtro1', '');
        formularioGarantias.append('comentOtro2', '');

        const fileUpload = $('.documentos');
        for (const archivo of fileUpload) {
            if (archivo.files.length > 0) {
                formularioGarantias.append(archivo.id, archivo.files[0]);
            }
        }
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.idContrato + '/' + this.API.user.abastecimientos + '/' + this.API.user.actualizar,
            'POST',
            formularioGarantias)
            // formularioGarantias
            .subscribe((response: any) => {
                let nombreCliente;
                if ( this.tipoCliente === 'FISICA' ) {
                    nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                } else if ( this.tipoCliente === 'MORAL' ) {
                    nombreCliente = this.cliente.razonSocial;
                } else if ( this.tipoCliente === 'ESPECIAL' ) {
                    nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                }
                // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                console.log(response);
                this.loginLoader = false;
                if ( response.Estatus === 201 ) {
                    // == Targets de notificación ==
                    let targets = response.Mensaje.notificacion;
                    targets.forEach(e => {
                        const target = e.target;
                        const id = e.id;
                        if (this.concepto === 'ALQUILER') {
                            this.mensajeNotificacionAR = 'El usuario ' + this.usuario.userName + ' ha modificado un abastecimiento del cliente: ' + nombreCliente;
                        } else {
                            this.mensajeNotificacionAR = 'El usuario ' + this.usuario.userName + ' ha modificado un reabastecimiento del cliente: ' + nombreCliente;
                        }
                        let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                        this.sendMessageTest(target, this.mensajeNotificacionAR, url, id);
                    });
                    // == Targets de notificación ==
                    // Swal('Correcto', response.Mensaje.strings, 'success');
                    // this.rutas.navigate(['dashboard/verCliente/', this.idCliente, 'contratos', this.idContrato, 'abastecimiento', this.IdAbas]);
                    this.ngOnInit();
                } else {
                    Swal('Error ' + response.Estatus, response.Mensaje, 'error');
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                this.loginLoader = false;
            }
        );
    }

    botonAutorizarCliente () {
        let bandera;
        let banderaDocumentos = false;
        let banderaContrato = false;
        if ( this.tipoCliente === 'ESPECIAL' && (this.contratoEstatusEstatus === 'AUTCOMP' || this.contratoEstatusEstatus === 'AUTPREE')) {
            banderaContrato = true;
        } else {
            // vas a darme todos los documentos que esten estatus y llenaras una bandera
            for (const documento of this.todosLosDocumentos) {
                if ( documento[0].estatus === 'AUTCOMP' && documento[0].tipoDocumento === 'PAGARE' ) {
                    banderaDocumentos = true;
                }
            }
        }
        // aqui tendremos que asignar un valor al tipo de person porque de ahi dependen los documentos
        // aqui lo que haremos sera que condicionemos que activen el boton
        if ( banderaContrato || banderaDocumentos ) {
            bandera = true;
        } else {
            Swal('Error', 'Faltan documentos por autorizar', 'warning');
            bandera = false;
        }
        return bandera;
    }

    autorizarAbastecimientoYContrato () {
        let bandera  = this.botonAutorizarCliente ();
        if (bandera) {
        const jsonData = {
            abastecimientoId: this.IdAbas,
            estatus: 'ORDPEND',
            noContrato: this.idContrato,
            idCliente: this.idCliente
        };
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos + '/' + this.API.user.autorizar,
            'POST',
            jsonData)
            .subscribe((response: any) => {
                    console.log(response);
                    if (response.Estatus === 201) {
                        Swal('Autorizado', response.Mensaje.strings, 'success');
                        // Aceptar la cotización generada por AdminPro.
                        if ( this.cotizacionId !== 0 || this.ordenId ) {
                            console.log( this.ordenId );
                            this.ordenAceptarRechazar('ORDAUTO');
                            console.log( 'Here' );
                        }
                        let nombreCliente;
                        if ( this.tipoCliente === 'FISICA' ) {
                            nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                        } else if ( this.tipoCliente === 'MORAL' ) {
                            nombreCliente = this.cliente.razonSocial;
                        } else if ( this.tipoCliente === 'ESPECIAL' ) {
                            nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                        }
                        // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                        // Falta notificación ya con actualización
                        let notificados = response.Mensaje.notificacion;
                        for (const noti of notificados) {
                            for ( const tarjets of noti ) {
                                console.log( this.concepto );
                                let target = tarjets.target;
                                let id = tarjets.id;
                                let notificacionString = 'El usuario ' + this.usuario.userName + ' ha autorizado un abastecimiento del cliente: ' + nombreCliente;
                                let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                                this.sendMessageTest(target, notificacionString, url, id);
                            }
                        }
                        // == Targets de notificación ==
                        // == Targets de notificación ==
                        // this.rutas.navigate(['dashboard/verCliente/', this.idCliente, 'contratos', this.idContrato, 'abastecimiento', this.IdAbas]);
                    } else if (response.Estatus === 202) {
                        Swal('Éxito', 'La revisión de documentos ha finalizado correctamente', 'info');
                    } else if (response.Estatus === 206) {
                        Swal('Atencion!', response.Mensaje, 'warning');
                    }
                }, err => {
                     console.log(err);
                    Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                    this.loginLoader = false;
                }
            );
        }
    }

    // Autorizar/rechazar contrato
    cambiarEstatusContrato (codFuncion) {
        const jsonData = {
            idDocumento: this.contratoAidi,
            estatus: codFuncion,
            tipoDocumento: 'CONTRATO',
            noContrato: this.idContrato,
            abastecimientoId: this.IdAbas
        };
        console.log( jsonData );
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.garantias + '/' + this.API.user.autorizar,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                if ( response.Estatus === 201 ) {
                // response.Mensaje.estatus
                // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre +' '+ this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                if (codFuncion === 'AUTCOMP') {
                    Swal('Correcto', response.Mensaje.strings, 'success');
                    let nombreCliente;
                    if ( this.tipoCliente === 'FISICA' ) {
                        nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                    } else if ( this.tipoCliente === 'MORAL' ) {
                        nombreCliente = this.cliente.razonSocial;
                    } else if ( this.tipoCliente === 'ESPECIAL' ) {
                        nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                    }
                    // == Targets de notificación ==
                    let targets = response.Mensaje[0].notificacion;
                    targets.forEach(e => {
                        const target = e.target;
                        const id = e.id;
                        let notificacionString =  'El usuario ' + this.usuario.userName + ' ha autorizado un contrato del cliente: ' + nombreCliente;
                        let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                        this.sendMessageTest(target, notificacionString, url, id);
                    });
                    // == Targets de notificación ==
                        this.detallesContrato();
                        // this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.urlContrato, 'abastecimiento']);
                        // response.Mensaje.estatus.nombre
                    } else if (codFuncion === 'AUTDENE') {
                        let nombreCliente;
                        if ( this.tipoCliente === 'FISICA' ) {
                            nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                        } else if ( this.tipoCliente === 'MORAL' ) {
                            nombreCliente = this.cliente.razonSocial;
                        } else if ( this.tipoCliente === 'ESPECIAL' ) {
                            nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                        }
                        Swal('Correcto', response.Mensaje.strings, 'success');
                        // == Targets de notificación ==
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha rechazado un contrato del cliente: ' + nombreCliente;
                            let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                        this.detallesContrato();
                    }
                } else {
                    Swal('Atención', response.Mensaje, 'warning');
                }
            }, err => {
                // console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                // Swal( 'Error', 'Algo anda mal...', 'error' );
            }
        );
    }
    // Autorizar/rechazar contrato

    // PREAUTORIZAR CONTRATO
    cambiarEstatusContratoPreautorizar() {
        const CONTRATOPREAT = {
            abastecimientoId: this.IdAbas,
            contratoId: this.contratoAidi
        };
        console.log( CONTRATOPREAT );
        this.network.callSecureService(
            // this.API.user.clientes + '/' +
            this.API.user.garantias + '/' + this.API.user.contrato + '/' + this.API.user.preautorizar,
            'POST',
            CONTRATOPREAT )
            .subscribe((response: any) => {
                console.log(response);
                if ( response.Estatus === 201 ) {
                    let nombreCliente;
                    if ( this.tipoCliente === 'FISICA' ) {
                        nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                    } else if ( this.tipoCliente === 'MORAL' ) {
                        nombreCliente = this.cliente.razonSocial;
                    } else if ( this.tipoCliente === 'ESPECIAL' ) {
                        nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                    }
                    // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                    Swal('Correcto', response.Mensaje.strings, 'success');
                        // == Targets de notificación ==
                        let targets = response.Mensaje[0].notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha pre-autorizado un contrato del cliente: ' + nombreCliente;
                            let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                        this.detallesContrato();
                        // this.ruta.navigate(['dashboard/verCliente', this.idCliente, 'contratos', this.urlContrato, 'abastecimiento']);
                        // response.Mensaje.estatus.nombre
                } else {
                    Swal('Atención', response.Mensaje, 'warning');
                }
            }, err => {
                // console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                // Swal( 'Error', 'Algo anda mal...', 'error' );
            }
        );
    }
    // PREAUTORIZAR CONTRATO

    FacturaRevisadaPorContabilidad () {
        const jsonData = {
            abastecimientoId: this.IdAbas,
            estatus: 'ORDPEND',
            noContrato: this.idContrato,
            idCliente: this.idCliente
        };
        console.log( jsonData );
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.abastecimientos + '/' + this.API.user.contabilidad + '/' + this.API.user.autorizar,
            'POST',
            jsonData)
            .subscribe((response: any) => {
                let nombreCliente;
                if ( this.tipoCliente === 'FISICA' ) {
                    nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                } else if ( this.tipoCliente === 'MORAL' ) {
                    nombreCliente = this.cliente.razonSocial;
                } else if ( this.tipoCliente === 'ESPECIAL' ) {
                    nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                }
                // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                console.log(response);
                console.log( jsonData );
                if (response.Estatus === 201) {
                    Swal('Autorizado', response.Mensaje.strings, 'success');
                    // Notificaiones para actualizar
                    /*
                    let notificados = response.Mensaje.notificacion;
                    for (const noti of notificados) {
                        let target = noti.target;
                        let notificacionString = 'El usuario ' + this.usuario.userName + ' ha revisado correctamente la información del cliente: ' + nombreCliente + ' del contrato: ' +  this.idContrato;
                        let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                        this.sendMessage(target, notificacionString, url);
                    }
                    */
                    // == Targets de notificación ==
                    let targets = response.Mensaje.notificacion;
                    targets.forEach(e => {
                        const target = e.target;
                        const id = e.id;
                        let notificacionString =  'El usuario ' + this.usuario.userName + ' ha revisado correctamente la información del cliente: ' + nombreCliente + ' del contrato: ' +  this.idContrato;
                        let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                        this.sendMessageTest(target, notificacionString, url, id);
                    });
                    // == Targets de notificación ==
                    // this.rutas.navigate(['dashboard/verCliente/', this.idCliente, 'contratos', this.idContrato, 'abastecimiento', this.IdAbas]);
                } else if (response.Estatus === 206) {
                    Swal('Atencion', 'Abastecimiendo ya revisado', 'warning');
                    // Swal('Atencion!', response.Mensaje, 'warning');
                }
            }, err => {
                console.log(err);
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
                this.loginLoader = false;
            }
        );
    }
    // Para actualizar contrato
    actualizarContrato() {
        const actualizarContrato: FormData = new FormData();
        this.loginLoader = true;

        actualizarContrato.append('noContrato', this.idContrato);
        // actualizarContrato.append('dias', this.dias);
        // actualizarContrato.append('fechaInicio', this.fechaInicio[0]);
        // actualizarContrato.append('fechaFin', this.fechaFin[0]);

        const fileUpload = $('#CONTRATO');
        actualizarContrato.append(fileUpload[0].id, fileUpload[0].files[0]);
        actualizarContrato.append('abastecimientoId',  this.IdAbas);

        this.network.callSecureService(
            this.API.user.clientes + '/' + this.idCliente + '/' + this.API.user.contratos + '/' + this.API.user.actualizar,
            'POST', actualizarContrato).subscribe((response: any) => {
                let nombreCliente;
                if ( this.tipoCliente === 'FISICA' ) {
                    nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno;
                } else if ( this.tipoCliente === 'MORAL' ) {
                    nombreCliente = this.cliente.razonSocial;
                } else if ( this.tipoCliente === 'ESPECIAL' ) {
                    nombreCliente = 'C.E.: ' + this.cliente.nombre + ' ' + this.cliente.paterno;
                }
                // this.tipoCliente === 'FISICA' ? nombreCliente = this.cliente.nombre + ' ' + this.cliente.paterno : nombreCliente = this.cliente.razonSocial;
                // console.log(response);
                if ( response.Estatus === 201 ) {
                    Swal('Correcto', 'Se actualizó con éxito', 'success');
                    // this.ruta.navigate(['dashboard/verCliente/' + this.idCliente + '/contratos/' + this.contrato + '/abastecimiento']);
                    // Aquí
                    if ( this.contratoEstatusEstatus === 'AUTPEND' ) {
                        // == Targets de notificación ==
                        let targets = response.Mensaje.notificacion;
                        targets.forEach(e => {
                            const target = e.target;
                            const id = e.id;
                            let notificacionString =  'El usuario ' + this.usuario.userName + ' ha actualizado un contrato del cliente: ' + nombreCliente;
                            let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                            this.sendMessageTest(target, notificacionString, url, id);
                        });
                        // == Targets de notificación ==
                    }
                    // Aquí
                } else {
                    console.log( response.Mensaje );
                }
            }, err => {
                console.log( err );
                 Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }
    // Para actualizar contrato
    // Comentario del contrato
    // Comentario de Contrato
    enviarComentarioContrato () {
        this.enviandoMensajeComentarioPopUp = true;
        const jsonData = {
            idContrato: this.contratoAidi,
            comentario: this.currentMensajeComentarioPopUp,
            abastecimientoId: this.IdAbas
        };
        // this.detallesContrato();
        this.network.callSecureService(
            this.API.user.clientes + '/' + this.API.user.contratos + '/' + this.API.user.agregarComentario,
            'POST',
            jsonData )
            .subscribe((response: any) => {
                // console.log(response);
                this.enviandoMensajeComentarioPopUp = false;
                this.currentMensajeComentarioPopUp = '';
                this.detallesContrato();
                // == Targets de notificación ==
                let targets = response.Mensaje.notificacion;
                targets.forEach(e => {
                    const target = e.target;
                    const id = e.id;
                    let notificacionString =  'El usuario ' + this.usuario.userName + ' ha comentado el contrato.';
                    let url = 'verCliente' + '/' + this.idCliente + '/' + 'contratos' + '/' + this.idContrato + '/' + 'abastecimiento' + '/' + this.IdAbas;
                    this.sendMessageTest(target, notificacionString, url, id);
                });
                // == Targets de notificación ==
            }, err => {
                 console.log(err);
                this.enviandoMensajeComentarioPopUp = false;
                Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
            }
        );
    }
    // Comentario del contrato
    // Funcion para enviar mensajes (por ahora notificaciones)
    sendMessageTest(target, notificacionString, url, id) {
        let mensaje = {
          mensaje: notificacionString,
          usuario: this.usuario.userName,
          target: target,
          tipo: 'notificacion',
          url: url,
          id: id
        };
       this.chat.sendMsg(mensaje);
    }

    sendMessage(target, notificacionString, url) {
        let mensaje = {
            mensaje: notificacionString,
            usuario: this.usuario.userName,
            target: target,
            tipo: 'notificacion',
            url: url
        };
       this.chat.sendMsg(mensaje);
    }


    public setInnerHtml(pdfurl: string) {
        this.innerHtml = this.sanitizer.bypassSecurityTrustHtml(
            "<object data='" + pdfurl + "' type='application/pdf' style='width:100%; height: 400px;'>" +
            'Object ' + pdfurl + ' failed' +
            '</object>');
    }

    comentarioDoble() {
        this.currentIdDocumento.comentVisto = false;
        const comentario = this.currentComentariosDocumento[this.currentComentariosDocumento.length -1];
        const jsonData = {
            comentarioId: comentario.comentarioId,
            tipoDocumento: 'GARANTIA'
        };
        this.network.callSecureService(
        // url
        'garantias/visto',
        // metodo
        'POST',
        // contentType
        jsonData
        ).subscribe((response) => {
            // console.log(response);
        }, err => {
             console.log(err);
             Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
        });
    }

    comentarioDobleContrato() {
        const comentario = this.comentariosContratoArray[this.comentariosContratoArray.length -1 ];
        this.vistoContrato = false;

        const jsonData = {
            comentarioId: comentario.comentarioId,
            tipoDocumento: 'CONTRATO'
        };
        this.network.callSecureService(
            // url
            'garantias/visto',
            // metodo
            'POST',
            // contentType
            jsonData
            ).subscribe((response) => {
                // console.log(response);
        }, err => {
            console.log(err);
            Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
        });
    }

    // Para imprimir
    print(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
            <html>
                <head>
                    <title></title>
                    <style>
                        .letraImprimir {
                            font-family: Arial;
                            font-weight: lighter;
                            font-size: 12px;
                        }
                        .tablas {
                            border: 1px solid black;
                        }
                    </style>
                </head>
                <body onload="window.print();window.close()">${printContents}</body>
                <footer>
                    <div style="text-align: right">
                        <img src="../../../assets/images/sm8footer.jpg" alt="95px" width="120px">
                    </div>
                </footer>
            </html>`
        );
        popupWin.document.close();
    }
    // Para imprimir

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/ver-editar-abastecimiento/ver-editar-abastecimiento.component.ts